<ng-container>
  <div class="welcome-container">
    <h1>{{ 'TalentOnboardInvitation.Title' | translate }}</h1>
    <p>{{ 'TalentOnboardInvitation.Description' | translate }}</p>

    <div class="email-input-container">
  <a-input
    type="email"
    [control]="email"
    class="form-control"
    [label]="'Auth.Email' | translate"
    [errorMessage]="getErrorMessage()"
    [isSubmitted]="formSubmitted"
    required>
  </a-input>
</div>


    <button
      class="is-btn is-btn__outfill header__public-signin"
      (click)="talentSignup()"
      [disabled]="email.invalid || inProgress">
      
      <span  class="round-loader is-trans" *ngIf="inProgress"></span>
      {{ 'TalentOnboardInvitation.SignUp' | translate }}
    </button>
  </div>
</ng-container>
